
<template>
  <div v-loading="loadAll" style="position:relative;">
    <div style="background-color: #fff;">
      <div class="fenlei">
        <div class="columnBoxInnner">
          <div class="columnBoxInnnerList">
            <div v-for="(item,index) in arrs" :key="index" :class="currrentindex==index?'activename':'column_a'" @click="changeNowColumn(item.value,index)">
              <span class="nameshow">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w1200 newsBox">
      <div class="crumbs">
        <div class="allNum">
          根籍搜索<span style="color: #ed4040;font-size: 16px"><span v-if="keys">"{{ keys }}"</span></span>为你找到<span>{{ currentCount }}</span>个结果,
          <span style="color: #ed4040;font-size: 16px;cursor: pointer" @click="gosearch2">站内搜索 <span v-if="keys">"{{ keys }}"</span>试试>></span>
        </div>
        <div class="dscDiv">
          <span :class="orderType==0?'avtivedsc':'noactivedsc'" @click="checkdsc(0)">综合排序</span>
          <span :class="orderType==1?'avtivedsc':'noactivedsc'" @click="checkdsc(1)">最新</span>
          <span :class="orderType==2?'avtivedsc':'noactivedsc'" @click="checkdsc(2)">热门</span>
        </div>
        <!--<span class="el-icon-location" />-->
        <!--<span class="sname" @click="gohome">首页</span>-->
        <!--<span>/搜索：{{ searchkey }}</span>-->
        <!--<span class="first_span">共找到</span><span class="marker">{{ currentCount }}</span><span>个结果，去</span><a href="http://i.pengzushijia.com" class="marker">总数据库</a><span>检索更多结果</span>-->
      </div>
      <div class="leftBox">
        <div style="background-color: #fff;">
          <!--<Centerlisthome :columnlist="currentData" />-->
          <div v-if="currentData.length>0" class="contentBox">
            <div v-if="!islogin" class="loginShadow" :style="'background-image:url('+listshadow+')'">
              <div class="contentlogin">
                <p>亲，告诉你个秘密:-D</p>
                <p>登录后，可以查看更多搜索结果哦！</p>
                <span class="loginbt" @click="showlogin">立即登录</span>
                <a class="registerbt" href="/register">免费注册</a>
              </div>
            </div>
            <div v-for="(item,index) in currentData" :key="index" class="contentBox_li">
              <div :class="item.RES_PHOTO?'hasImg':'noImg'">
                <p><span class="types">{{ item.RES_TYPE|changetype }}</span><span class="msgnames" @click="goread(item)" v-html="item.RES_NAME" /></p>
                <div v-if="item.RES_TYPE!=2" class="msgDetail">
                  {{ item.RES_CONTENT }}
                </div>
                <div v-else class="msgDetail">
                  {{ item.RES_CONTENT|changeShidai }}
                </div>
                <div class="msgfoot">
                  <span>{{ item.NICKNAME }}</span>
                  <span class="msgtime">{{ item.CREATE_DATE|changeTime4 }}</span>
                </div>
              </div>
              <div v-if="item.RES_PHOTO" class="msgImg" @click="goread(item)">
                <img :src="item.RES_PHOTO" alt="">
              </div>
            </div>
          </div>
          <div v-else class="noData">
            暂无数据
          </div>
          <div v-show="currentData.length>0" class="pageNation">
            <el-pagination
              :current-page="currentPage"
              :page-sizes="[10, 30, 50,100 ]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="currentCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
          <!--<div v-if="loadAll" class="atfoot loadMore">-->
          <!--已经到底部了-->
          <!--</div>-->
          <!--<div v-else class="loadMore" @click="addMore">-->
          <!--加载更多>>-->
          <!--</div>-->
        </div>
      </div>
      <div class="rightBox">
        <div class="title">
          相关推荐
        </div>
        <div class="center_rightBox">
          <div v-for="(item,index) in InterestedData" :key="index" class="right_lis">
            <div class="tipname_right_lis">
              {{ item.TEMPLATE_ID|changetitle }}
            </div>
            <a class="imglis" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank">
              <img :src="item.CONTENT_PHOTO_SMALL" alt="">
            </a>
            <a class="msg" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank">
              {{ item.CONTENT_TITLE }}
            </a>
          </div>
        </div>
        <!--<div v-if="keys" class="btn_rightBox">-->
        <!--查看更多" <span style="color: #ed4040;cursor: pointer">{{ keys }}</span> "相关搜索-->
        <!--</div>-->
      </div>
    </div>
    <el-dialog
      custom-class="loginBoxs"
      :visible.sync="seelogin"
      width="850px"
      :before-close="handleClose"
    >
      <loginShow />
    </el-dialog>
  </div>
</template>
<script>
import Rightlist from '@/components/commonRightList'
import Centerlisthome from '@/components/centerlist_specTopic_detial/index.vue'
import { InterestedHome, searchRes } from '@/api/api.js'
import loginShow from '@/components/logincomponent/index.vue'
import { ssoUserLogin } from '@/api/api.js'
import axios from 'axios'
export default {
  inject: ['reload'],
  components: { Rightlist, Centerlisthome, loginShow },
  head() {
    // var listObj = this.$store.state.hotList_home
    var titles = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    if (this.searchkey) {
      titles = this.searchkey
    }
    return {
      title: '搜索：' + titles + '-彭祖世家网',
      mateDesc: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作，基于聚脉网络旗下国家发明专利技术产品“大谱师-互联网家谱协作编纂平台”进行品牌定制，专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。',
      keys: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'
    }
  },
  filters: {
    changetype: value => {
      if (value == 1) {
        return '家谱'
      } else if (value == 2) {
        return '谱系'
      } else if (value == 3) {
        return '谱文'
      } else {
        return '人物'
      }
    },
    changeShidai: value => {
      if (value) {
        var numToZHCNStr = function(num, yearBol) {
          var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
          var numStr = parseInt(num).toString().split('')
          if (isNaN(parseInt(num))) {
            numStr = ['0']
          }
          if (yearBol) {
            var Str = ''
            for (var i = 0; i < numStr.length; i++) {
              Str += chnNumChar[parseInt(numStr[i])]
            }
            return Str
          } else {
            if (numStr.toString() == '1,0') {
              return '十'
            }
            if (numStr.length == 1) {
              return chnNumChar[parseInt(numStr[0])]
            } else if (numStr.length == 2) {
              if (parseInt(numStr[0]) == 1) {
                return '十' + chnNumChar[parseInt(numStr[1])]
              } else {
                return chnNumChar[parseInt(numStr[0])] + chnNumChar[parseInt(numStr[1])]
              }
            } else {
              var Str2 = ''
              for (var i = 0; i < numStr.length; i++) {
                Str2 += chnNumChar[parseInt(numStr[i])]
              }
              return Str2
            }
          }
        }
        var changnum = function(str) {
          var newarry = str.split(',')
          if (newarry.length > 1) {
            var newstr = ''
            for (let i = 0; i < newarry.length; i++) {
              var item = newarry[i]
              var itemnew = item.split('=')
              if (itemnew.length > 1) {
                var newitem = itemnew[0] + '(' + '第' + numToZHCNStr(itemnew[1]) + '世' + ')'
                newstr += newitem
                if (i < newarry.length - 1) {
                  newstr += '、'
                }
              } else {
                item += ','
                newstr += item
              }
            }
            return newstr
          } else {
            if (str.indexOf('=') !== -1) {
              return str.split('=')[0] + '(' + '第' + numToZHCNStr(str.split('=')[1]) + '世' + ')'
            } else {
              return str
            }
          }
        }
        return changnum(value)
      } else {
        return ''
      }
    },
    changetitle: value => {
      var newvalue = ''
      switch (value) {
        case 'NEWS':
          newvalue = '资讯'
          break
        case 'DOC':
          newvalue = '文库'
          break
        case 'PHOTO':
          newvalue = '图集'
          break
        case 'VIDEO':
          newvalue = '视频'
          break
        default:
          newvalue = ''
      }
      return newvalue
    },
    changeheighText: value => {
      // var result = value.replace(new RegExp(this.keys, 'g'), `<span class="primary_title"></span>`)

    }
  },
  data() {
    return {
      seelogin: false,
      listshadow: require('@/static/listshadow.png'),
      islogin: false,
      InterestedData: [],
      orderType: 0,
      keys: '',
      searchlogo: require('@/static/allData_logo.png'),
      currrentindex: 0,
      loadAll: true,
      arrs: [
        { name: '全部', value: '0' },
        { name: '在线家谱', value: '1' },
        { name: '望族世系', value: '2' },
        { name: '谱牒文摘', value: '3' },
        { name: '人物传记', value: '4' }
      ],
      currentData: '',
      currentPage: 1,
      size: 10,
      page: 1,
      currentType: '0',
      currentCount: 0
    }
  },
  computed: {
    searchkey() {
      return this.$route.query.searchName
    }
  },
  watch: {
    $route(to, from) {
      console.log(to)
      if (to.name === 'asv') {
        if (to.query.type) {
          this.currentType = to.query.type
          this.currrentindex = to.query.type
        }
        this.loadAll = true
        this.init(1, 10)
      }
    }
  },
  mounted() {
    localStorage.removeItem('isback')
    ssoUserLogin().then(res => {
      if (res.data.userId) {
        this.setloca('userid', res.data.userId, 7200)
        localStorage.removeItem('unionid')
        this.islogin = true
      } else {
        this.islogin = false
      }
    })
    InterestedHome().then(res => {
      this.InterestedData = res.data
    })
    if (this.$route.query.type) {
      this.currentType = this.$route.query.type
      this.currrentindex = this.$route.query.type
    }
    this.loadAll = true
    this.init(1, 10)
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    changeNowColumn: function(type, index) {
      this.$router.push({ path: '/allDataSearch', query: { searchName: this.keys, type: type }})
      this.currrentindex = index
      this.loadAll = true
      this.currentPage = 1
      this.currentType = type
      this.init(1, 10)
    },
    init: function(page, size) {
      if (page) {
        this.currentPage = page
      }
      if (size) {
        this.size = size
      }
      var obj = {}
      obj.index = this.currentPage
      if (this.$route.query.searchName) {
        obj.str = this.$route.query.searchName
        this.keys = this.$route.query.searchName
      } else {
        this.keys = ''
      }
      obj.orderType = this.orderType
      obj.size = this.size
      obj.resType = this.currentType
      // var url = 'http://admin.pengzushijia.com/jointat-mfb-admin/portalBook/searchRes'
      // axios.post(url, obj)
      //   .then(res => {
      //     var newdata = res.data.listMapData
      //     var str = /^http/
      //     for (var i = 0; i < newdata.length; i++) {
      //       if (newdata[i].RES_NAME) {
      //         var newstr = newdata[i].RES_NAME.replace(new RegExp(this.keys, 'g'), '<span class="keyworldtext">' + this.keys + '</span>')
      //         newdata[i].RES_NAME = newstr
      //       }
      //       if (!str.test(newdata[i].CONTENT_PHOTO) && newdata[i].CONTENT_PHOTO) {
      //         newdata[i].CONTENT_PHOTO_NAME = newdata[i].CONTENT_PHOTO
      //       }
      //     }
      //     this.currentData = newdata
      //     this.currentCount = res.data.count
      //     this.loadAll = false
      //   })
      searchRes(obj).then(res => {
        var newdata = res.data.pager.listMapData
        var keys2 = res.data.TraditionalChinese
        var str = /^http/
        for (var i = 0; i < newdata.length; i++) {
          if (!str.test(newdata[i].CONTENT_PHOTO) && newdata[i].CONTENT_PHOTO) {
            newdata[i].CONTENT_PHOTO_NAME = newdata[i].CONTENT_PHOTO
          }
          if (newdata[i].RES_NAME && this.keys && keys2) {
            var newstr = newdata[i].RES_NAME.replace(new RegExp(this.keys, 'g'), '<span class="keyworldtext">' + this.keys + '</span>')
            var newstr2 = newstr.replace(new RegExp(keys2, 'g'), '<span class="keyworldtext">' + keys2 + '</span>')
            newdata[i].RES_NAME = newstr2
          }
        }
        this.currentData = newdata
        this.currentCount = res.data.count
        this.loadAll = false
      })
    },
    gohome: function() {
      this.$router.push({ path: '/home' })
    },
    goSearch: function() {
      this.$router.push({ path: '/allDataSearch', query: { searchName: this.keys }})
      this.loadAll = true
      this.init(1, 10)
    },
    handleSizeChange(sizes) {
      this.loadAll = true
      this.init(1, sizes)
      // this.fetchData(this.option.param)
    },
    handleCurrentChange(page) {
      this.loadAll = true
      this.init(page)
      // this.fetchData(this.option.param)
    },
    checkdsc: function(index) {
      this.orderType = index
      this.loadAll = true
      this.init(1, 10)
    },
    goread: function(item) {
      var id = item.RES_ID
      var type = item.RES_TYPE
      var newtype = ''
      if (type == 2) {
        newtype = 3
      }
      if (type == 3) {
        newtype = 2
      }
      if (newtype) {
        type = newtype
      }
      if (type == 4) {
        id = item.NODE_ID
      }
      var url = '/checkRead?id=' + id + '&type=' + type
      window.open(url, '_blank')
      // this.$message({
      //   type: 'warning',
      //   message: '该功能暂未开放'
      // })
    },
    goallData: function() {
      window.open('http://maker.pengzushijia.com/project/allDataBase', '_black')
    },
    gosearch2() {
      const { href } = this.$router.resolve({
        path: '/search',
        name: 'search',
        query: {
          'searchName': this.keys
        }
      })
      window.open(href, '_blank')
    },
    showlogin() {
      this.seelogin = true
    },
    handleClose() {
      this.seelogin = false
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .loginShadow{
    position: absolute;
    height: 200vh;
    width: 880px;
    top: 468px;
    left: 0;
    z-index: 2;
    .contentlogin{
      overflow: hidden;
      margin-top: 220px;
      text-align: center;
      p{
        text-align: center;
        font-size: 18px;
        margin-bottom: 16px;
        color: #333;
      }
      .loginbt{
        display: inline-block;
        width: 120px;
        text-align: center;
        padding: 8px 8px;
        background-color: #FD485E;
        color: #ffffff;
        margin-top: 15px;
        cursor: pointer;
        border-radius: 3px;
        &:hover{
          background-color: #dd1e32;
        }
      }
      .registerbt{
        display: inline-block;
        width: 120px;
        text-align: center;
        padding: 8px 8px;
        background-color: #128BED;
        margin-left: 25px;
        color: #ffffff;
        margin-top: 15px;
        cursor: pointer;
        border-radius: 3px;
        &:hover{
          background-color: #146ca4;
        }
      }
    }
  }

  .noData{
    text-align: center;
    color: #ccc;
    font-size: 20px;
    font-weight: 600;
    padding: 20px 0;
  }
  .contentBox{
    overflow: hidden;
    padding: 0 20px;
    min-height: 1300px;
    .contentBox_li{
      border-bottom: 1px solid #F2F2F2;
      padding: 20px 0;
      overflow: hidden;
      .msgImg{
        width: 100px;
        height: 134px;
        display: inline-block;
        cursor: pointer;
        img{
          width: 100px;
          height: 134px;
        }
      }
      .hasImg{
        display: inline-block;
        vertical-align: top;
        height: 134px;
        /*padding-left: 20px;*/
        width: 720px;
        p{
          .types{
            width: 40px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            display: inline-block;
            background-color: #E3003A;
            border-radius: 4px;
            color: #ffffff;
          }
          .msgnames{
            margin-left: 10px;
            overflow: hidden;
            font-size: 17px;
            font-weight: 600;
            cursor: pointer;
          }
        }
        .msgDetail{
          height: 70px;
          margin-top: 10px;
          font-size: 12px;
          color: #666666;
        }
        .msgfoot{
          font-size: 12px;
          color: #999999;
          margin-top: 16px;
          span{
            font-size: 12px;
          }
          .msgtime{
            margin-left: 15px;
          }
        }
      }
      .noImg{
        width: 100%;
        p{
          .types{
            width: 40px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            display: inline-block;
            background-color: #E3003A;
            border-radius: 4px;
            color: #ffffff;
          }
          .msgnames{
            margin-left: 10px;
            overflow: hidden;
            font-size: 17px;
            font-weight: 600;
            cursor: pointer;
          }
        }
        .msgDetail{
          margin-top: 10px;
          margin-bottom: 10px;
          overflow: hidden;
          font-size: 12px;
          color: #666666;
        }
        .msgfoot{
          font-size: 12px;
          color: #999999;
          margin-top: 16px;
          span{
            font-size: 12px;
          }
          .msgtime{
            margin-left: 15px;
          }
        }
      }
    }
  }
    .pageNation{
        padding:30px 0;
        text-align: center;
    }
    .first_span{
        margin-left: 40px;
    }
    .marker{
        color: #ed4040;
    }
    .sname{
        color: #ed4040;
        cursor: pointer;
    }
    .atfoot{
        cursor: auto;
    }
    .loadMore{
        text-align: center;
        margin: 20px 0;
        color: #939393;
        font-size: 14px;
        cursor: pointer;
        display:inline-block;
        width: 100%;
        &:hover{
            color: #ed4040;
        }
    }
    .newsBox{
        background-color: #F9F9F9;
        overflow: hidden;
        position: relative;
    }
    .fenlei{
      margin: 0 auto;
      width: 1200px;
      overflow: hidden;
      text-align: left;
      background-color: #fff;
      height: 50px;
      line-height: 50px;
      .column_a{
        display: inline-block;
        cursor: pointer;
        font-size: 16px;
        height: 48px;
        line-height: 48px;
        margin-right: 35px;
        .a_span{
          margin: 0 10px;
        }
        .nameshow{
          font-size: 16px;
          color: #333333;
          &:hover{
            color: #ed4040;
          }
        }
      }
      .activename{
        display: inline-block;
        cursor: pointer;
        height: 48px;
        line-height: 48px;
        margin-right: 35px;
        border-bottom: 2px solid #FF0000;
        .a_span{
          margin: 0 10px;
        }
        .nameshow{
          color: #ed4040;
          font-size: 16px;
        }

      }
    }
    .crumbs{
      /*border: 1px solid #e5e5e5;*/
      color: #808080;
      background-color: #fff;
      padding: 20px 0;
      margin-top: 20px;
      padding-left: 20px;
      overflow: hidden;
      .allNum{
        font-size: 16px;
        color: #999999;
        display: inline-block;
        max-width: 888px;
        span{
          max-width: 500px;
        }
      }
      .gohome{
        cursor: pointer;
      }
      .dscDiv{
        display: inline-block;
        float: right;
        .avtivedsc{
          margin-right: 50px;
          font-size: 12px;
          color: #E3003A;
          cursor: pointer;
          padding: 5px 10px;
          border: 1px solid #E3003A;
          border-radius: 5px;
        }
        .noactivedsc{
          margin-right: 50px;
          font-size: 12px;
          color: #666666;
          cursor: pointer;
        }
      }
    }
    .leftBox{
        width: 880px;
        margin-right: 20px;
        margin-top: 20px;
        float: left;
        .imgBox{
            margin-top: 20px;
            height: 300px;
            position: relative;
            background-color: #fff;
            img{
                width: 100%;
                height: 100%;
            }
            p{
                position: absolute;
                text-align: center;
                width: 880px;
                color:#ffffff;
            }
            .names{
                height: 40px;
                line-height: 40px;
                top: 130px;
                font-size: 28px;
            }
            .times{
                top: 170px;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
            }
        }
        .specialAbstract_box{
            background-color: #fff;
            overflow: hidden;
            .specialAbstract{
                margin:20px 30px;
                background-color: #fafafa;
                overflow: hidden;
                padding: 10px 25px;
                font-size: 12px;
                color: #4d4d4d;
            }
        }

    }
    .rightBox{
        width: 300px;
        /*margin-left: 20px;*/
        margin-top: 20px;
        float: right;
        /*top: 0;*/
        /*right: 0;*/
        overflow: hidden;
      background-color: #fff;
      padding-bottom: 20px;
      .title{
        margin-top: 20px;
        height: 20px;
        line-height: 20px;
        border-left: 2px solid #ed4040;
        padding-left: 10px;
        font-size: 16px;
        margin-left: 15px;
      }
      .center_rightBox{
        padding-bottom: 20px;
        overflow: hidden;
        .right_lis{
          margin-top: 15px;
          width: 131px;
          height: 140px;
          display: inline-block;
          vertical-align: top;
          padding-left: 15px;
          position: relative;
          .tipname_right_lis{
            width: 40px;
            height: 20px;
            border-radius: 3px;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            color: #ffffff;
            position: absolute;
            top: 2px;
            left: 17px;
            background-color: rgba(0,0,0,.3);
          }
          .imglis{
            width: 126px;
            height: 84px;
            display: inline-block;
            img{
              width: 126px;
              height: 84px;
            }
          }
          .msg{
            width: 126px;
            margin-top: 10px;
            height: 40px;
            font-size: 14px;
            color: #333333;
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
      .btn_rightBox{
        height: 38px;
        width: 298px;
        line-height: 38px;
        text-align: center;
        font-size: 14px;
        border: 1px solid #F0F0F0;
      }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
      .fenlei{
        width: 100%;
      }
        .leftBox{
            width: 100%;
            margin-top: 0;
            min-height: 70vh;
            .crumbs{
              margin-bottom: 10px;
              padding: 0 20px;
            }
            .bannerBox{
                width: 100%;
                height: auto;
            }
            .fenlei{
                padding-top: 15px;
            }
        }
        .rightBox{
            display: none;
        }
        .columnBoxInnner{
            width: 100%;
            overflow: hidden;
            padding-bottom: 20px;
            overflow-x: auto;
            padding-top: 10px;
            .columnBoxInnnerList{
                /*margin-top: 10px;*/
                white-space: nowrap;
                padding: 0 20px;
            }
        }
      .contentBox .contentBox_li .hasImg{
        width: 70%;
      }
      .contentBox .contentBox_li .msgImg{
        width: 30%;
      }
      .contentBox .contentBox_li .hasImg .msgDetail{
        height: 67px;
        margin-top: 10px;
        font-size: 12px;
        color: #666666;
        overflow: hidden;
      }
      .noData{
        margin-top: 20px;
      }
      .loginShadow{
        width: 100%;
      }
    }
</style>
